var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "summarypopup" },
    _vm._l(_vm.dataList, function(items, itemsIndex) {
      return _c(
        "div",
        { key: itemsIndex, staticClass: "summarypopup-inner" },
        _vm._l(items, function(item, index) {
          return _c("div", { key: index, staticClass: "data" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t(item.label)))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v("\n            " + _vm._s(item.value) + " \n            "),
              _c("span", { staticClass: "unit" }, [
                _vm._v(_vm._s(_vm.$t(item.unit)))
              ])
            ])
          ])
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }